<template>
  <div>

    <div class="my-container">
      <h2>Methods introduction</h2>
      <div id="tab1">
        <el-tabs v-model="activeName1" type="card" @tab-click="handleClick" stretch style="margin-top: 10px">
          <el-tab-pane label="Compare" name="first">
            <h3>Compare methods for inferring copy number variation</h3>
            <div style="display: flex;justify-content: center;align-items: center;">
              <div>
                <div style="margin: 0 auto">
                  <el-table
                      :data="tableData"
                      :row-style="{height: '10px'}"
                      :cell-style="{padding: '0', color: 'black', margin: '0'}"
                      :header-cell-style="{padding: '0', margin: '0', color: 'black'}"
                      stripe
                      border>
                    <el-table-column
                        prop="title"
                        label=""
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="inferCNV"
                        label="inferCNV"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        prop="copyKat"
                        label="copyKat"
                        width="300">
                    </el-table-column>
                    <el-table-column
                        prop="STARCH"
                        label="STARCH"
                        width="310">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="inferCNV" name="second">
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
              <div class="content">
                <div class="left">
                  <img src="../../assets/inferCNV/inferCNV2.png" width="70%"/>
                  <div style="text-align: center">InferCNV official document.</div>
                </div>
                <div class="right">
                  <h3 style="background-color: #aaaaaa;width: 90%">Schematic diagram of InferCNV official document</h3>
                  <div style="width: 90%;text-align: justify;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;InferCNV is used to explore single-cell RNA-seq data in tumors to analyze large-scale chromosomal copy number alterations (CNA) in somatic cells, such as gains or deletions of entire chromosomes or large segments of chromosomes. The working principle is to use a set of "normal" cells as a reference to analyze the changes in the intensity of gene expression at various positions on the tumor genome. The relative expression of genes on each chromosome is displayed in the form of a heat map, relative to normal cells, the tumor genome always overexpressed or underexpressed. InferCNV provides some filtering parameters, which can be adjusted to reduce noise and better reveal the signal supporting CNA. Additionally inferCNV includes methods for predicting CNA intervals and methods for defining cell populations based on patterns of heterogeneity.</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="copyKat" name="third">
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
              <div class="content">
                <div class="left">
                  <img src="../../assets/inferCNV/copykat.png" style="width: 70%"/>
                  <div style="text-align: center">Ruli Gao et al. Nature Biotechnology. 2021.</div>
                </div>
                <div class="right">
                  <h3 style="background-color: #aaaaaa;width: 90%">Overview of the CopyKAT analysis workflow</h3>
                  <div style="width: 90%;text-align: justify">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a, The CopyKAT workflow begins with a UMI count matrix to order genes by their genomic positions and uses the raw count matrix to perform log-Freeman Turkey Transformation to stabilize variance and smooth outliers using a polynomial dynamic linear model. b, A subset of normal cells is defined using integrative clustering and GMM method to infer the copy number baseline. c, Relative gene expression values in single cells are used for MCMC segmentation and segments are merged by KS testing. d, Aneuploid tumor and normal cell clusters are classified using a normal cell enrichment and GMM distribution tests. e, Clonal substructure of tumor cells are delineated by clustering and subclones are used for differential expression analysis.</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="STARCH" name="forth">
            <div class="content">
              <div class="left">
                <img src="../../assets/inferCNV/STARCH.png" style="width: 70%"/>
                <div style="text-align: center">Rebecca Elyanow et al. Physical Biology. 2021.</div>
              </div>
              <div class="right">
                <h3 style="background-color: #aaaaaa;width: 90%">Overview of the STARCH analysis workflow</h3>
                <div style="width: 90%;text-align: justify">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(a)The inputs to STARCH are a spatial transcriptomics dataset consisting of a spot×gene expression matrix X and the spatial locations of each spot. The outputs are an assignment of each spot to one of K clones and a copy number profile (CNP) for each clone. (b) The STARCH model. Clone assignments Z are modeled by a Hidden Markov Random Field (HMRF), where the hidden states are the clone assignments of the spotsand the observed values are the transcript counts in X. The emission probabilities of each spot are computed from a Hidden Markov Model (HMM) that describes the CNP of each clone and chromosome arm.</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="my-container">
      <h2>Try these methods</h2>
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
<!--        <div style="word-spacing: 5px;line-height: 25px">-->
<!--          如果您想分析自己的空间转录组数据，初步推测拷贝数变异以及恶性程度的情况，请按照以下格式上传您的数据，并填写邮箱耐心等待结果。-->
<!--          <br/>-->
<!--          注意：你可以选择一种或多种方法分析您的数据。该工作完成后分析时间较长，提交数据前请认真检查的您的数据，感谢配合！-->
<!--        </div>-->
<!--        <br/>-->
        <div style="width: 70%;text-align:left;word-spacing: 5px;line-height: 25px">
          <h3>Overview</h3>
          <p>
            Taking a set of breast cancer spatial transcription data as an example, the three methods of InferCNV, CopyKat, and STARCH were used to infer the number of chromosomal copy variations, and the inference results were visualized on the slice. Red indicates the variant area, green indicates the normal area, and yellow indicates unknown regions (Fig. 1), and compared with hand-annotated region classifications (Fig. 2).
          </p>
          <div class="my-div-center">
            <div style="width: 50%;">
              <div class="my-div-center">
                <img src="../../assets/cnv/figure1_source.png" width="100%"/>
              </div>
              <p style="text-align: center">Figure1 Visualization results on slices.</p>
            </div>
            <div style="width: 50%;">
              <div class="my-div-center">
                <img style="width: 40%" src="../../assets/cnv/figure2.png" width="100%"/>
              </div>
              <p style="text-align: center">Figure2 Human annotation results of slices.</p>
            </div>
          </div>
        </div>

        <!--      <div style="display: flex;flex-flow:  row nowrap;justify-content: space-between;width: 70%;">-->
        <!--        <div>-->
        <!--          <el-upload-->
        <!--              class="upload-demo"-->
        <!--              action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--              :on-change="handleChange1"-->
        <!--              :file-list="fileList1">-->
        <!--            inferCNV提交文件-->
        <!--            <el-button size="small">点击上传</el-button>-->
        <!--&lt;!&ndash;            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>&ndash;&gt;-->
        <!--          </el-upload>-->
        <!--        </div>-->
        <!--        <div>-->
        <!--          <el-upload-->
        <!--              class="upload-demo"-->
        <!--              action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--              :on-change="handleChange2"-->
        <!--              :file-list="fileList2">-->
        <!--            copyKat提交文件-->
        <!--            <el-button size="small">点击上传</el-button>-->
        <!--&lt;!&ndash;            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>&ndash;&gt;-->
        <!--          </el-upload>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div style="display: flex;flex-flow:  row nowrap;justify-content: space-between;width: 70%;">-->
        <!--        <el-upload-->
        <!--            class="upload-demo"-->
        <!--            action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--            :on-change="handleChange3"-->
        <!--            :file-list="fileList1">-->
        <!--          STARCH提交文件-->
        <!--          <el-button size="small">点击上传</el-button>-->
        <!--&lt;!&ndash;          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>&ndash;&gt;-->
        <!--        </el-upload>-->
        <!--        <div style="display: inline">-->
        <!--          <el-input v-model="email" placeholder="请输入邮箱" style="width: 200px"></el-input>-->
        <!--          <el-button size="small">点击提交</el-button>-->
        <!--        </div>-->
        <!--      </div>-->

      </div>
      <div id="tab2">
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick" stretch style="margin-top: 10px">
          <el-tab-pane label="inferCNV" name="first">
            <div class="my-div-center">
              <div style="width: 70%;text-align:left;word-spacing: 5px;line-height: 25px">
                <h3>InferCNV</h3>
                <p style="text-align:left;word-spacing: 5px;line-height: 25px">
                  When using this method, you need to provide the folder where the three files generated by the upstream alignment analysis of the spatial transcriptome data are located, representing the cell label (barcode), gene ID (feature), and expression data (matrix) respectively (Fig. 3). We will call InferCNV in the scCancer package in the background to infer the chromosomal copy variation number, and finally get the cell and its corresponding label (malignant/nonMalignant/unknown). If you also provide spatial location information and image information, it is recommended that you upload your preprocessed standard RDS file, and the system will visualize the inferred results (Fig. 4) for your further analysis and observation.
                </p>
              </div>
            </div>
<!--            <div class="my-div-center">-->
<!--              <img src="../assets/cnv/figure3.png"/>-->
<!--            </div>-->
<!--            <p style="text-align: center">Figure3 Input of InferCNV.</p>-->
            <div class="my-div-center">
              <img src="../../assets/cnv/figure4.png"/>
            </div>
            <p style="text-align: center">Figure3 Visualization results of InferCNV.</p>

            <div class="my-div-center">
              <el-form ref="form" label-width="80px" size="small" style="width: 50%;">
                <el-form-item label="barcodes:">
                  <input type="file" ref="file1"/>
                </el-form-item>
                <el-form-item label="features:">
                  <input type="file" ref="file2"/>
                </el-form-item>
                <el-form-item label="matrix:">
                  <input type="file" ref="file3"/>
                </el-form-item>
                <el-form-item label="rds:">
                  <input type="file" ref="file4"/>
                </el-form-item>
                <el-form-item label="email:">
                  <input type="email" ref="email1"/>
                  <button v-on:click="sendCheckCode1" style="margin-left: 20px">get code</button>
                </el-form-item>
                <el-form-item label="code:">
                  <input type="text" ref="checkCode1"/>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button v-on:click="uploadFormdata1" style="margin-top: 20px">upload</el-button>
                  <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!--          <div class="my-div-center">-->
            <!--            <span>barcodes: </span>-->
            <!--            <input type="file" ref="file1"/>-->
            <!--            <span>features: </span>-->
            <!--            <input type="file" ref="file2"/>-->
            <!--            <span>matrix: </span>-->
            <!--            <input type="file" ref="file3"/>-->
            <!--          </div>-->
            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>email: </span>-->
            <!--            <input type="email" ref="email1"/>-->
            <!--            <button v-on:click="sendCheckCode1" style="margin-left: 20px">get check code</button>-->
            <!--          </div>-->
            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>check code: </span>-->
            <!--            <input type="text" ref="checkCode1"/>-->
            <!--          </div>-->
            <!--          <div class="my-div-center">-->
            <!--            <el-button v-on:click="uploadFormdata1" style="margin-top: 20px">upload</el-button>-->
            <!--            <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>-->
            <!--          </div>-->

          </el-tab-pane>
          <el-tab-pane label="copyKat" name="second">
            <div class="my-div-center">
              <div style="width: 70%;text-align:left;word-spacing: 5px;line-height: 25px">
                <h3>CopyKat</h3>
                <p style="text-align:left;word-spacing: 5px;line-height: 25px">
                  When using this method, you need to provide the behavioral gene name and the gene expression matrix of the spatial transcriptome data listed as the spot name (Fig. 5). We will call the CopyKat method in the background to infer the number of chromosome copy variations, and finally get the cell and its corresponding label (aneuploid/diploid/unknown). If you also provide spatial location information and image information, it is recommended that you upload your preprocessed standard RDS file, and the system will visualize the inferred results (Fig. 6) for your further analysis and observation.
                </p>
              </div>
            </div>
            <div class="my-div-center">
              <img src="../../assets/cnv/figure5.png"/>
            </div>
            <p style="text-align: center">Figure4 Input of CopyKat.</p>
            <div class="my-div-center">
              <img src="../../assets/cnv/figure6.png"/>
            </div>
            <p style="text-align: center">Figure5 Visualization results of CopyKat.</p>


            <div class="my-div-center">
              <el-form ref="form" label-width="80px" size="small" style="width: 50%;">
                <el-form-item label="input:">
                  <input type="file" ref="file5"/>
                </el-form-item>
                <el-form-item label="rds:">
                  <input type="file" ref="file6"/>
                </el-form-item>
                <el-form-item label="email:">
                  <input type="email" ref="email2"/>
                  <button v-on:click="sendCheckCode2" style="margin-left: 20px">get code</button>
                </el-form-item>
                <el-form-item label="code:">
                  <input type="text" ref="checkCode2"/>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button v-on:click="uploadFormdata2" style="margin-top: 20px">upload</el-button>
                  <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!--          <div class="my-div-center">-->
            <!--            <span>input: </span>-->
            <!--            <input type="file" ref="file4"/>-->
            <!--            <span>rds: </span>-->
            <!--            <input type="file" ref="file5"/>-->
            <!--          </div>-->

            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>email: </span>-->
            <!--            <input type="email" ref="email2"/>-->
            <!--            <button v-on:click="sendCheckCode2" style="margin-left: 20px">get check code</button>-->
            <!--          </div>-->
            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>check code: </span>-->
            <!--            <input type="text" ref="checkCode2"/>-->
            <!--          </div>-->

            <!--          <div class="my-div-center">-->
            <!--            <el-button v-on:click="uploadFormdata2" style="margin-top: 20px">upload</el-button>-->
            <!--            <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>-->
            <!--          </div>-->

          </el-tab-pane>
          <el-tab-pane label="STARCH" name="third">
            <div class="my-div-center">
              <div style="width: 70%;text-align:left;word-spacing: 5px;line-height: 25px">
                <h3>STARCH</h3>
                <p style="text-align:left;word-spacing: 5px;line-height: 25px">
                  When using this method, you need to provide the behavioral gene name and the gene expression matrix of the spatial transcriptome data listed as the spot name (Fig. 7). We will call the CopyKat method in the background to infer the number of chromosome copy variations , and finally get the cell and its corresponding label (aneuploid/diploid/unknown). If you also provide spatial location information and image information, it is recommended that you upload your preprocessed standard RDS file, and the system will visualize the inferred results (Fig 8) for your further analysis and observation.
                 </p>
              </div>
            </div>
            <div class="my-div-center">
              <img src="../../assets/cnv/figure7.png"/>
            </div>
            <p style="text-align: center">Figure6 Input of STARCH.</p>
            <div class="my-div-center">
              <img src="../../assets/cnv/figure8.png"/>
            </div>
            <p style="text-align: center">Figure7 Visualization results of STARCH.</p>

            <div class="my-div-center">
              <el-form ref="form" label-width="80px" size="small" style="width: 50%;">
                <el-form-item label="input:">
                  <input type="file" ref="file7"/>
                </el-form-item>
                <el-form-item label="rds:">
                  <input type="file" ref="file8"/>
                </el-form-item>
                <el-form-item label="email:">
                  <input type="email" ref="email3"/>
                  <button v-on:click="sendCheckCode3" style="margin-left: 20px">get code</button>
                </el-form-item>
                <el-form-item label="code:">
                  <input type="text" ref="checkCode3"/>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button v-on:click="uploadFormdata3" style="margin-top: 20px">upload</el-button>
                  <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>
                </el-form-item>
              </el-form>
            </div>

            <!--          <div class="my-div-center">-->
            <!--            <span>input: </span>-->
            <!--            <input type="file" ref="file6"/>-->
            <!--            <span>rds: </span>-->
            <!--            <input type="file" ref="file7"/>-->
            <!--          </div>-->

            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>email: </span>-->
            <!--            <input type="email" ref="email3"/>-->
            <!--            <button v-on:click="sendCheckCode3" style="margin-left: 20px">get check code</button>-->
            <!--          </div>-->
            <!--          <div class="my-div-center" style="margin-top: 20px">-->
            <!--            <span>check code: </span>-->
            <!--            <input type="text" ref="checkCode3"/>-->
            <!--          </div>-->

            <!--          <div class="my-div-center">-->
            <!--            <el-button v-on:click="uploadFormdata3" style="margin-top: 20px">upload</el-button>-->
            <!--            <el-button v-on:click="clearFiles" style="margin-top: 20px;margin-left: 100px">clear select</el-button>-->
            <!--          </div>-->

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="my-container">
      <h2>Give typical examples</h2>
      <el-container style="position:relative;">
        <el-aside width="15%" style="min-width: 200px; max-height: 1000px">
          <el-menu
              unique-opened
              :default-active="active.toString()"
              mode="vertical"
              @select="handleSelect">
            <div v-for="(item, i) in tableData2" :key="i">
              <template v-if="item.length !== 0">
                <el-submenu :index="i">
                  <template slot="title">
                    <span style="margin: 0;padding: 0;color: black;float: left"><b>{{i}}</b></span>
                  </template>
                  <el-menu-item-group v-for="(it, j) in item" :key="j">
                    <el-menu-item :index="generateIndex(i,j)"
                                  style="margin: 0;padding: 0;width: 80px;float:right;">
                      {{it.name}}
                    </el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </template>
            </div>
<!--            <template v-if="tableData2.BreastCancer.length !== 0">-->
<!--              <el-submenu index="0">-->
<!--                <template slot="title">-->
<!--                  <span>Breast cancer</span>-->
<!--                </template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.BreastCancer" :key="i">-->
<!--                  <template v-if="tableData2.BreastCancer.length === 0" slot="title">No data</template>-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.cSCC.length !== 0">-->
<!--              <el-submenu index="1">-->
<!--                <template slot="title">-->
<!--                  &lt;!&ndash;              <i class="el-icon-location"></i>&ndash;&gt;-->
<!--                  <span>Skin cancer</span>-->
<!--                </template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.cSCC" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.PDAC.length !== 0">-->
<!--              <el-submenu index="2">-->
<!--                <template slot="title"><span>PDAC</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.PDAC" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.ProstateCancer.length !== 0">-->
<!--              <el-submenu index="3">-->
<!--                <template slot="title"><span>Prostate cancer</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.ProstateCancer" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.Melanoma.length !== 0">-->
<!--              <el-submenu index="4">-->
<!--                <template slot="title"><span>Melanoma</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.Melanoma" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.OvarianCancer.length !== 0">-->
<!--              <el-submenu index="5">-->
<!--                <template slot="title"><span>Ovarian cancer</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.OvarianCancer" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.Glioblastoma.length !== 0">-->
<!--              <el-submenu index="6">-->
<!--                <template slot="title"><span>Glioblastoma</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.Glioblastoma" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.ColorectalCancer.length !== 0">-->
<!--              <el-submenu index="7">-->
<!--                <template slot="title"><span>Colorectal Cancer</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.ColorectalCancer" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.LiverCancer.length !== 0">-->
<!--              <el-submenu index="8">-->
<!--                <template slot="title"><span>Liver Cancer</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.LiverCancer" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
<!--            <template v-if="tableData2.LungCancer.length !== 0">-->
<!--              <el-submenu index="9">-->
<!--                <template slot="title"><span>Lung Cancer</span></template>-->
<!--                <el-menu-item-group v-for="(item,i) in tableData2.LungCancer" :key="i">-->
<!--                  <el-menu-item :index="i">{{item.name}}</el-menu-item>-->
<!--                </el-menu-item-group>-->
<!--              </el-submenu>-->
<!--            </template>-->
          </el-menu>
        </el-aside>
        <el-main>
          <div  class="my-div-center">
            <div style="width: 10%">methods</div>
            <div style="width: 30%">spatial slice distribution</div>
            <div style="width: 30%">UMAP</div>
            <div style="width: 30%">T-SNE</div>
          </div>
          <hr/>
          <template v-if="active === 0 || active === 'BreastCancer'">
            <template v-if="tableData2.BreastCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.BreastCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BreastCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.BreastCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BreastCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.BreastCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BreastCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.BreastCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BreastCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 1 || active === 'PDAC'">
            <template v-if="tableData2.PDAC[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.PDAC[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.PDAC[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.PDAC[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.PDAC[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.PDAC[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.PDAC[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.PDAC[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.PDAC[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 2 || active === 'cSCC'">
            <template v-if="tableData2.cSCC[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.cSCC[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.cSCC[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.cSCC[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.cSCC[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.cSCC[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.cSCC[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.cSCC[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.cSCC[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 3 || active === 'Melanoma'">
            <template v-if="tableData2.Melanoma[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.Melanoma[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Melanoma[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.Melanoma[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Melanoma[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.Melanoma[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Melanoma[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BreastCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 4 || active === 'ProstateCancer'">
            <template v-if="tableData2.ProstateCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.ProstateCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ProstateCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.ProstateCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ProstateCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.ProstateCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ProstateCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ProstateCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 5 || active === 'LiverCancer'">
            <template v-if="tableData2.LiverCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.LiverCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LiverCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.LiverCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LiverCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.LiverCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LiverCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.LiverCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LiverCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 6 || active === 'OvarianCancer'">
            <template v-if="tableData2.OvarianCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.OvarianCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.OvarianCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.OvarianCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.OvarianCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.OvarianCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.OvarianCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.OvarianCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.OvarianCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 7 || active === 'Glioblastoma'">
            <template v-if="tableData2.Glioblastoma[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.Glioblastoma[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Glioblastoma[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.Glioblastoma[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Glioblastoma[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.Glioblastoma[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Glioblastoma[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.Glioblastoma[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Glioblastoma[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 8 || active === 'ColorectalCancer'">
            <template v-if="tableData2.ColorectalCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.ColorectalCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ColorectalCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.ColorectalCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ColorectalCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.ColorectalCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.ColorectalCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.ColorectalCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.ColorectalCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 9 || active === 'CervicalCancer'">
            <template v-if="tableData2.CervicalCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.CervicalCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.CervicalCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.CervicalCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.CervicalCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.CervicalCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.CervicalCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.CervicalCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.CervicalCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 10 || active === 'IntestineCancer'">
            <template v-if="tableData2.IntestineCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.IntestineCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.IntestineCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.IntestineCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.IntestineCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.IntestineCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.IntestineCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.IntestineCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.IntestineCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 11 || active === 'BladderCancer'">
            <template v-if="tableData2.BladderCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.BladderCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BladderCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.BladderCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BladderCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.BladderCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.BladderCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.BladderCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.BladderCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 12 || active === 'Brainmetastases'">
            <template v-if="tableData2.Brainmetastases[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.Brainmetastases[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Brainmetastases[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.Brainmetastases[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Brainmetastases[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.Brainmetastases[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.Brainmetastases[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.Brainmetastases[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.Brainmetastases[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>
          <template v-else-if="active === 13 || active === 'LungCancer'">
            <template v-if="tableData2.LungCancer[active_name].real_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">real</div>
                <img :src=tableData2.LungCancer[active_name].real_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].real_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].real_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LungCancer[active_name].inferCNV_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">inferCNV</div>
                <img :src=tableData2.LungCancer[active_name].inferCNV_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].inferCNV_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].inferCNV_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LungCancer[active_name].copyKat_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">copyKat</div>
                <img :src=tableData2.LungCancer[active_name].copyKat_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].copyKat_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].copyKat_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
            <template v-if="tableData2.LungCancer[active_name].STARCH_num !== 0">
              <div  class="my-div-center">
                <div style="width: 10%">STARCH</div>
                <img :src=tableData2.LungCancer[active_name].STARCH_path.path[0] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].STARCH_path.path[1] width="30%"  alt="pic load error">
                <img :src=tableData2.LungCancer[active_name].STARCH_path.path[2] width="30%"  alt="pic load error">
              </div>
            </template>
          </template>

        </el-main>
      </el-container>
    </div>


  </div>

</template>

<script>
export default {
  name: "InferCNV",
  data() {
    return {
      active: 0,
      active_name: 0,
      activeName1: 'first',
      activeName2: 'first',
      // index0: 0,
      // index1: 0,
      // index2: 0,
      // index3: 0,
      // index4: 0,
      // index5: 0,
      // index6: 0,
      // index7: 0,
      // index8: 0,
      // index9: 0,
      tableData: [
          {
            title: 'Scope',
            inferCNV: 'scRNA-seq',
            copyKat: 'scRNA-seq',
            STARCH: 'STRNA-seq'
          },
          {
            title: 'Input',
            inferCNV: 'Gene expression matrix',
            copyKat: 'Gene expression matrix',
            STARCH: 'Gene expression matrix Position coordinates'
          },
          {
            title: 'Output',
            inferCNV: 'Malignancy estimation',
            copyKat: 'Aneuploid prediction & subtumor prediction',
            STARCH: 'gene x clone CNV matrix & a spot label vector'
          },
        {
          title: 'Run time',
          inferCNV: '30mins',
          copyKat: '120mins',
          STARCH: ''
        },
          {
            title: 'Effect',
            inferCNV: 'Acceptable',
            copyKat: 'Acceptable',
            STARCH: 'Better'
         },
        {
          title: 'Year and Journal',
          inferCNV: '2020 Nature Communications',
          copyKat: '2021 Nature Biotechnology',
          STARCH: '2021 Physical Biology'
        }
      ],
      email: '',
      tableData2: {
        "PDAC": [],
        "OvarianCancer": [],
        "LungCancer": [],
        "Melanoma": [],
        "Glioblastoma": [],
        "BreastCancer": [],
        "ProstateCancer": [],
        "ColorectalCancer": [],
        "LiverCancer": [],
        "cSCC": []
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    };
  },
  mounted() {
    // console.log(this.tableData2.BreastCancer.length === 0)
    this.getImg()
  },
  methods: {
    getImg(){
      let _this = this
      // console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/inferCNV/img/')
          .then(function (response){
            console.log('img:')
            console.log(response)
            _this.tableData2 = response.data
            console.log(response.data)
            for (let x in response.data){
              console.log(x)
            }
          })
    },
    generateIndex(i, j){
      return i+"_"+j;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleSelect(key,keyPath){
      // console.log(key,keyPath);
      // console.log(key);
      console.log(keyPath[0]+"  "+keyPath[1]);
      let no = keyPath[1].split('_')[1]
      console.log(no)
      if (keyPath[1] !== null){
        // this.active = Number(keyPath[0])
        this.active = keyPath[0]
        this.active_name = no
      }
    },
    uploadFormdata1(){
      let _this = this
      let formData=new FormData();
      formData.append('files',this.$refs.file1.files[0])
      formData.append('files',this.$refs.file2.files[0])
      formData.append('files',this.$refs.file3.files[0])
      formData.append('files',this.$refs.file4.files[0])
      formData.append('email',this.$refs.email1.value)
      formData.append('checkcode',this.$refs.checkCode1.value)
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/infercnv/sccancer',
          formData,
          {
            headers:{
              'Content-Type': 'multipart/form-data; boundary = ' + new Date().getTime()
              //这里要把content-type设置为multipard/form-data，同时还要设置boundary
            }
          }).then(result=>{
        this.$message.success("upload success")
            console.log(result)
          }).catch(err=>{
        console.log(err)
      })
    },
    uploadFormdata2(){
      let _this = this
      let formData=new FormData();
      formData.append('files',this.$refs.file5.files[0])
      formData.append('files',this.$refs.file6.files[0])
      formData.append('email',this.$refs.email2.value)
      formData.append('checkcode',this.$refs.checkCode2.value)
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/infercnv/copykat',
          formData,
          {
            headers:{
              'Content-Type': 'multipart/form-data; boundary = ' + new Date().getTime()
              //这里要把content-type设置为multipard/form-data，同时还要设置boundary
            }
          }).then(result=>{
        this.$message.success("upload success")
        console.log(result)
      }).catch(err=>{
        console.log(err)
      })
    },
    uploadFormdata3(){
      let _this = this
      let formData=new FormData();
      formData.append('files',this.$refs.file7.files[0])
      formData.append('files',this.$refs.file8.files[0])
      formData.append('email',this.$refs.email3.value)
      formData.append('checkcode',this.$refs.checkCode3.value)
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/infercnv/starch',
          formData,
          {
            headers:{
              'Content-Type': 'multipart/form-data; boundary = ' + new Date().getTime()
              //这里要把content-type设置为multipard/form-data，同时还要设置boundary
            }
          }).then(result=>{
            this.$message.success("upload success")
        console.log(result)
      }).catch(err=>{
        console.log(err)
      })
    },
    clearFiles(){
      this.$refs.file1.value = ''
      this.$refs.file2.value = ''
      this.$refs.file3.value = ''
      this.$refs.file4.value = ''
      this.$refs.file5.value = ''
      this.$refs.file6.value = ''
      this.$refs.file7.value = ''
      this.$refs.file8.value = ''
      this.$refs.email1.value = ''
      this.$refs.checkCode1.value = ''
      this.$refs.email2.value = ''
      this.$refs.checkCode2.value = ''
      this.$refs.email3.value = ''
      this.$refs.checkCode3.value = ''
    },
    sendCheckCode1(){
      let _this = this
      console.log()
      let formData={"email": this.$refs.email1.value}
      // formData.email= this.$refs.email
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/email',
          formData,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
      ).then(result=>{
        this.$message.success("send success")
        console.log(result)
      })
    },
    sendCheckCode2(){
      let _this = this
      console.log()
      let formData={"email": this.$refs.email2.value}
      // formData.email= this.$refs.email
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/email',
          formData,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
      ).then(result=>{
        this.$message.success("send success")
        console.log(result)
      })
    },
    sendCheckCode3(){
      let _this = this
      console.log()
      let formData={"email": this.$refs.email3.value}
      // formData.email= this.$refs.email
      this.$axios.post('http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/email',
          formData,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
      ).then(result=>{
        this.$message.success("send success")
        console.log(result)
      })
    }
  }
}
</script>

<style scoped>
.content{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.left{
  width: 50%;
  float: right;
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: flex-end;*/
  /*align-items: flex-end;*/
}
.right{
  width: 50%;
  float: left;
}
.el-form-item{
  /*float: left;*/

}
#tab1 /deep/ .el-tabs__item.is-active{
  color:#3F78C1 !important;
  font-weight: bold;
}
#tab1 /deep/ .el-tabs__item:hover {
  /*background-color: #00BFFF;*/
  background-color: #3F78C1;
  color: #FFFFFF !important;
  /*font-size: 25px;*/
  /*border-bottom: none;*/
}
#tab2 /deep/ .el-tabs__item.is-active{
  color:#3F78C1 !important;
  font-weight: bold;
}
#tab2 /deep/ .el-tabs__item:hover {
  /*background-color: #00BFFF;*/
  background-color: #3F78C1;
  color: #FFFFFF !important;
  /*font-size: 25px;*/
  /*border-bottom: none;*/
}
</style>
